// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-leaderboard-tsx": () => import("./../../../src/pages/leaderboard.tsx" /* webpackChunkName: "component---src-pages-leaderboard-tsx" */),
  "component---src-templates-article-template-tsx": () => import("./../../../src/templates/article.template.tsx" /* webpackChunkName: "component---src-templates-article-template-tsx" */),
  "component---src-templates-articles-template-tsx": () => import("./../../../src/templates/articles.template.tsx" /* webpackChunkName: "component---src-templates-articles-template-tsx" */),
  "component---src-templates-author-template-tsx": () => import("./../../../src/templates/author.template.tsx" /* webpackChunkName: "component---src-templates-author-template-tsx" */)
}

